import { render, staticRenderFns } from "./TrainingDetails.vue?vue&type=template&id=0167d306&"
import script from "./TrainingDetails.vue?vue&type=script&lang=js&"
export * from "./TrainingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrainingDetails.vue"
export default component.exports